import { render, staticRenderFns } from "./AssignFormsConsultations.vue?vue&type=template&id=444227fc&"
import script from "./AssignFormsConsultations.vue?vue&type=script&lang=js&"
export * from "./AssignFormsConsultations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports